import { render, staticRenderFns } from "./InformationAdministrator.vue?vue&type=template&id=5b50dd12"
import script from "./InformationAdministrator.vue?vue&type=script&lang=js"
export * from "./InformationAdministrator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports